// src/components/common/Input.jsx
import React from 'react'

const Input = React.forwardRef(
    ({ label, error, helperText, className = '', ...props }, ref) => {
        return (
            <div className="w-full">
                {label && (
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                        {label}
                    </label>
                )}
                <input
                    ref={ref}
                    className={`
            w-full px-3 py-2 border rounded-lg shadow-sm 
            focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500
            ${error ? 'border-red-500' : 'border-gray-300'}
            ${className}
          `}
                    {...props}
                />
                {(error || helperText) && (
                    <p className={`mt-1 text-sm ${error ? 'text-red-600' : 'text-gray-500'}`}>
                        {error || helperText}
                    </p>
                )}
            </div>
        )
    }
)

export default Input
